import type { TopCountries } from '../../../../domain/company';
import { CountryService } from '../../../../services/country/country';
import { formatPercentage } from '../../../../services/numberFormat';

import {
  StyledCountryIcon,
  StyledCountryShareName,
  StyledCountrySharePercentage,
  StyledCountryShareValueCell,
  StyledProgressBar,
} from './styles';

export type TopCountryRow = TopCountries['countries'][number];

export const CountryShareTableRow = ({ item }: { item: TopCountryRow }) => {
  const { country: countryCode, share } = item;
  const countryName = CountryService.getCountryName(countryCode);
  const shareFormatted = formatPercentage(share, 2);

  return (
    <>
      <StyledCountryShareName data-automation={`TrafficCountry-${countryName}`}>
        <StyledCountryIcon countryCode={countryCode} />
        {countryName}
      </StyledCountryShareName>
      <StyledCountryShareValueCell>
        <StyledCountrySharePercentage>{shareFormatted}</StyledCountrySharePercentage>
        <StyledProgressBar progress={shareFormatted} />
      </StyledCountryShareValueCell>
    </>
  );
};
